
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.228 0v2.114c2.896.883 5.011 3.633 5.011 6.886s-2.115 5.993-5.011 6.876V18c4.01-.934 7.016-4.608 7.016-9S15.237.934 11.228 0zm2.506 9c0-1.816-1.003-3.376-2.506-4.136v8.24c1.503-.728 2.506-2.298 2.506-4.104zM.202 5.921v6.158h4.01l5.011 5.13V.79L4.211 5.921H.201z","fill":"#9B9A9A"}})])
          )
        }
      }
    